import { SubjectReconciliationModalStateId } from '@features/paymentReconciliationModal/enums/SubjectReconciliationModalStateId'

export const getPaymentRegistrationModalView = (
  canUsePrepayment: boolean,
  billHasMatchSuggestion: boolean,
  isCreditNoteSelected: boolean,
) => {
  if (!isCreditNoteSelected && canUsePrepayment) {
    return SubjectReconciliationModalStateId.Prepayment
  }
  if (billHasMatchSuggestion) {
    return SubjectReconciliationModalStateId.Match
  }

  return SubjectReconciliationModalStateId.BankLines
}
